export const PERIODS = Object.freeze({
  MONTHLY: { key: "mensal", label: "Mensal", moe: 6.7, severity: "warning" },
  QUARTERLY: {
    key: "trimestral",
    label: "Trimestral",
    moe: 4.0,
    severity: "ok",
  },
  SEMESTER: {
    key: "semestral",
    label: "Semestral",
    moe: 2.9,
    severity: "excellent",
  },
  ANNUAL: { key: "anual", label: "Anual", moe: 2.0, severity: "excellent" },
});

export const PERIOD_ORDER = ["mensal", "trimestral", "semestral", "anual"];
export const DEFAULT_PERIOD = "trimestral";
